import { ApiHelper } from '@nv/react-commons/src/Services'
import baseSaga from 'containers/Base/saga'
import injectSaga from 'utils/injectSaga'

export default [
  // Main Sagas
  injectSaga({ key: 'commons', saga: ApiHelper.saga }),
  injectSaga({ key: 'global', saga: baseSaga })
]
